// Generated by scripts/syncOnlyOfficeEnv.js — do not edit.
// Source: (no .env found; defaults)
// Keys: ONLYOFFICE_ENABLED, ONLYOFFICE_URL

const onlyOfficeEnv =
{
    enabled: false,
    url: ''
};

export { onlyOfficeEnv };
